import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e5bdf20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "unitindex" }
const _hoisted_2 = { class: "row mt-4 mb-3" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = {
  key: 0,
  class: "loading"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Daten werden geladen...", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "skilltable personal"
}
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "row mt-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 namecontainer" }, null, -1))
const _hoisted_11 = { class: "offset-6 col-6 mt-2 mb-2 filterbuttons" }
const _hoisted_12 = { class: "col-4" }
const _hoisted_13 = { class: "col-8" }
const _hoisted_14 = {
  key: 1,
  class: "row"
}
const _hoisted_15 = { class: "col-8" }
const _hoisted_16 = {
  key: 0,
  class: "outer-file-list"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "outer-file-list" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Projektzusammenarbeiten", -1))
const _hoisted_20 = { class: "col-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Headline = _resolveComponent("Headline")!
  const _component_TableTabs = _resolveComponent("TableTabs")!
  const _component_Legend = _resolveComponent("Legend")!
  const _component_UserDropdown = _resolveComponent("UserDropdown")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Skill = _resolveComponent("Skill")!
  const _component_Bar = _resolveComponent("Bar")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_EntwicklungsPlan = _resolveComponent("EntwicklungsPlan")!
  const _component_FileList = _resolveComponent("FileList")!
  const _component_Zusammenarbeit = _resolveComponent("Zusammenarbeit")!
  const _directive_hasperms = _resolveDirective("hasperms")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Headline, {
      h1: "Skillübersicht",
      h2: `von ${_ctx.user ? _ctx.user.firstname + ' ' + _ctx.user.lastname : 'Lade...'}`
    }, null, 8, ["h2"]),
    (_ctx.isManager)
      ? (_openBlock(), _createBlock(_component_TableTabs, {
          key: 0,
          active: "data"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Legend, {
          withTarget: "",
          horizontal: ""
        })
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (tipe) => {
      return (_openBlock(), _createBlock(_component_Accordion, {
        title: tipe.name,
        key: tipe.name
      }, {
        default: _withCtx(() => [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
            : _createCommentVNode("", true),
          (!_ctx.loading && _ctx.filteredSkills(tipe.type).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(["row header", { fixed: _ctx.fixed }]),
                  ref_for: true,
                  ref: "header"
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        (_ctx.gradingusers.length > 0)
                          ? (_openBlock(), _createBlock(_component_UserDropdown, {
                              key: 0,
                              class: _normalizeClass(["button", { active: _ctx.barTableFilter != 'avg' && _ctx.barTableFilter != 'self' && _ctx.barTableFilter != 'manager' && _ctx.barTableFilter != 'set' }]),
                              users: _ctx.gradingusers,
                              onChanged: _ctx.filterTable
                            }, null, 8, ["users", "onChanged", "class"]))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterTable('avg'))),
                          class: _normalizeClass({ active: _ctx.barTableFilter == 'avg' })
                        }, [
                          _createVNode(_component_Tooltip, { text: "360° Feedback" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Durschnitt aller Einschätzungen, die für den Skill abgegeben wurden, inklusive Führungskraft und Selbsteinschätzung.")
                            ]),
                            _: 1
                          })
                        ], 2),
                        _createElementVNode("button", {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterTable('set'))),
                          class: _normalizeClass({ active: _ctx.barTableFilter == 'set' })
                        }, "Abgestimmter Wert", 2)
                      ])
                    ])
                  ])
                ], 2),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSkills(tipe.type), (skill) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "row bartable",
                    key: `${skill}`
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_Skill, {
                        skill: skill,
                        isFuture: skill.future.includes(_ctx.user.unit_id),
                        isStrategic: skill.strategic.includes(_ctx.user.unit_id),
                        isLeadership: skill.leadership
                      }, null, 8, ["skill", "isFuture", "isStrategic", "isLeadership"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      (_ctx.filteredBarTable[skill.id])
                        ? (_openBlock(), _createBlock(_component_Bar, {
                            key: 0,
                            value: _ctx.filteredBarTable[skill.id].value,
                            target: _ctx.filteredBarTable[skill.id].target,
                            history: _ctx.filteredBarTable[skill.id].history
                          }, null, 8, ["value", "target", "history"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["title"]))
    }), 128)),
    (_ctx.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_EntwicklungsPlan, {
              unit: _ctx.user.id
            }, null, 8, ["unit"]),
            (_ctx.user.files.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (_ctx.user.files.length > 0)
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_17, "Dateien"))
                    : _createCommentVNode("", true),
                  (_ctx.user.files.length > 0)
                    ? (_openBlock(), _createBlock(_component_FileList, {
                        key: 1,
                        files: JSON.parse(_ctx.user.files)
                      }, null, 8, ["files"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_Zusammenarbeit, {
                user: _ctx.user.id
              }, null, 8, ["user"])
            ])), [
              [_directive_hasperms, ['user.all.manage', 'user.unit.manage', 'user.allbutceo.manage']]
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_Legend, {
              withTarget: "",
              noheader: ""
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}